import Paragraphs from "../Paragraphs";

const textColorClass = {
    white: "text-white",
    "blue-dark": "text-blue-dark",
};

function BandHeading({ title, paragraphs, textColor = "white", widthClass = "w-full md:w-3/5" }) {
    return (
        <div className={`w-full m-auto ${textColorClass[textColor] || "text-white"}`}>
            {title && (
                <div className="text-2xl text-golden w-full font-bold">{title}</div>
            )}
            {paragraphs && (
                <div className={`mt-8 md:mb-16 text-1xl ${widthClass}`}>
                    <Paragraphs paragraphs={paragraphs} />
                </div>
            )}
        </div>
    );
}

export default BandHeading;
